( function () {
	'use strict';

	function editTemplateReferenceCtrl ( modalInstance, uiTemplateReferenceModel ) {
		var self = this;

		self.ctrl        = uiTemplateReferenceModel.ctrl;
		self.cancelModal = modalInstance.dismiss;
	}

	editTemplateReferenceCtrl.$inject = [ '$modalInstance', 'uiTemplateReferenceModel' ];

	angular
		.module( 'app.templates' )
		.controller( 'editTemplateReferenceCtrl', editTemplateReferenceCtrl );
} )();
